// Urls
import { roundUpNearestInteger } from "../../common-utils/number-utils/NumberUtils";
import {
  downloadRouteAnalysisPdfReportUrl,
  getRouteSummaryUrl,
} from "../../urls/mavin-tools/RouteAnalysisURL";

// Utils
import {
  downloadFile,
  sendCreateOrUpdateRequest,
} from "../../utils/api/apiUtils";
import { getToken } from "../../utils/token";

export async function getRouteSummaryFn(
  stretchId,
  targetGroupId,
  startTS,
  duration
) {
  // Request Headers
  const headerParams = {
    "Content-Type": "application/json",
  };

  const body = {
    startTS,
    durationInDays: duration,
  };

  // optional parameter
  if (targetGroupId) {
    body.targetGroupId = targetGroupId;
  }

  const url = getRouteSummaryUrl.replace(":roadStretchId", stretchId);

  return sendCreateOrUpdateRequest(url, body, true, "POST", headerParams);
}

export async function downloadRouteAnalysisPdfReportFn(
  cityName,
  stretchId,
  targetGroupId,
  startTS,
  durationInDays,
  mapCenter,
  mapZoom
) {
  const headerParams = {
    Authorization: "Bearer " + getToken(),
  };

  // string => "lat,lng"
  const centerAsString = mapCenter.join(",");

  // round off zoom
  const roundOffZoom = roundUpNearestInteger(mapZoom);

  // params
  const params = {
    city: cityName,
    startTS,
    durationInDays,
    center: centerAsString,
    zoom: roundOffZoom,
  };

  // optional parameter
  if (targetGroupId) {
    params.targetGroupId = targetGroupId;
  }

  return downloadFile(
    downloadRouteAnalysisPdfReportUrl.replace(":roadStretchId", stretchId),
    true,
    headerParams,
    params
  );
}
